module.exports = __webpack_public_path__ + "static/media/process-file-type-pic.0b928fa5.svg";